import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgUrl = (u) => {
  if (!u) return "";
  return u.startsWith("http") ? u : `${BACKEND_URL}${u}`;
};

export const WHATSAPP_URL = "https://wa.me/905444690246";

export const COMPANY = {
  name: "İnegöl Mobilya",
  phones: ["0544 469 02 46", "0534 963 39 47", "0482 502 10 07"],
  email: "alibozdemir474747@hotmail.com",
  address: "13 Mart Mah. Vali Ozan Cad. Teras1 Sitesi A/Blok, Artuklu / MARDİN",
  instagram: "inegolmobilyamardin",
};
